// @ts-nocheck

import React, { useCallback, useState } from 'react';
import styled from 'styled-components';

import type { Licence } from '../../types/common';
import HistoryItemCashoutButton from '../HistoryItemCashoutButton';
import HistoryItemCashoutButtonEnhance from '../HistoryItemCashoutButtonEnhance';
import HistoryItemCashoutSelector from '../HistoryItemCashoutSelector';

const ButtonWrapper = styled.div`
  display: flex;
  padding: 0.33em 1em 1em;
  gap: 1em;

  & > * {
    flex: 1;
  }
`;

type HistoryItemCashOutButtonsProps = {
  isCashoutAvailable: boolean;
  isCompleteBetAvailable: boolean;
  isCompleteBetDisabled: boolean;
  cashoutValue: number;
  cashoutStatus: boolean | null | undefined;
  cashoutAvailable: boolean;
  licence: Licence;
  id: number;
  cashout: unknown;
  cashoutEnhance: unknown;
};

const HistoryItemCashoutButtons = ({
  isCashoutAvailable,
  isCompleteBetAvailable,
  isCompleteBetDisabled,
  cashoutValue,
  cashoutStatus,
  cashoutAvailable,
  licence,
  id,
  cashout,
  cashoutEnhance,
}: HistoryItemCashOutButtonsProps) => {
  const [showCashoutSelector, setShowCashoutSelector] = useState(false);
  const [cashoutAmount, setCashoutAmount] = useState(cashoutValue);

  const onCashoutClick = useCallback(() => {
    if (cashoutAmount !== cashoutValue) {
      cashout(id, cashoutValue, cashoutAmount);
    } else {
      cashout(id, cashoutValue);
    }
  }, [id, cashoutValue, cashout, cashoutAmount]);

  if (!isCashoutAvailable && !isCompleteBetAvailable) {
    return null;
  }

  return (
    <>
      {showCashoutSelector ? (
        <HistoryItemCashoutSelector
          cashoutValue={cashoutValue}
          cashoutStatus={cashoutStatus}
          licence={licence}
          cashoutAmount={cashoutAmount}
          onCashoutChange={setCashoutAmount}
        />
      ) : null}
      <ButtonWrapper>
        {isCashoutAvailable ? (
          <HistoryItemCashoutButton
            onCashoutSubmit={onCashoutClick}
            cashoutValue={cashoutValue}
            cashoutAvailable={cashoutAvailable}
            cashoutStatus={cashoutStatus}
            cashoutAmount={cashoutAmount}
            showSelector={showCashoutSelector}
            onShowSelector={setShowCashoutSelector}
          />
        ) : null}
        {isCompleteBetAvailable ? (
          <HistoryItemCashoutButtonEnhance id={id} cashoutEnhance={cashoutEnhance} isDisabled={isCompleteBetDisabled} />
        ) : null}
      </ButtonWrapper>
    </>
  );
};

export default HistoryItemCashoutButtons;
